import { connect } from "react-redux";

import { RootState } from "../../../../reducers";
import { ChallengeStyle } from "../../../../shared/services/enums";
import SubmitChallenge from "./SubmitChallenge";

interface OwnProps {
  isOpen: boolean;
  onSubmit: () => void;
  onFinishSubmitChallenge: (type: ChallengeStyle) => void;
  onCancel: () => void;
  type: ChallengeStyle;
  score: number;
  totalScore: number;
}

const mapStateToProps = (state: RootState, props: OwnProps) => {
  const {
    lastSavedAt,
    lastTestRanAt,
    hasUnsaved,
    challengeSubmitted,
    challengeSubmitting,
  } = state.applicant.challengeEditorContext;

  return {
    hasUnsaved,
    notLatestExecution:
      ChallengeStyle.isCodingTypeChallenge(props.type) &&
      lastSavedAt !== lastTestRanAt,
    submitting: challengeSubmitting,
    submitted: challengeSubmitted,
    ...props,
  };
};

export default connect(mapStateToProps, () => ({}))(SubmitChallenge);
